import { withGlobal } from 'components/global/GlobalWrapper'
import { NewStructure } from './NewStructure'
import { buildingStructuresReducers } from 'components/stores/building_structures/reducers'

export default withGlobal(NewStructure, { reducers: buildingStructuresReducers })
